<div class="tab-pane fade show active" id="Thermals" role="tabpanel">
  <app-asset-static-info class="fixed_status_bar"></app-asset-static-info>

  <div class="inner_gauge_box row col-md-12">
    <div class="chart_boxes_outer_V2">
      <app-gauge-card
        class="ch_box b1 col-md-2 position-relative"
        type="transformer"
        title="Bushing Temperature"
        [url]="sensorData + '/oil-temperature/' + serialNo"
        metric_type=""
        asset_id=""
      >
      </app-gauge-card>
      <app-gauge-card
        class="ch_box b2 col-md-2 position-relative"
        type="transformer"
        title="Connector Temperature"
        [url]="sensorData + '/oil-level/' + serialNo"
        metric_type=""
        asset_id=""
      >
      </app-gauge-card>
      <app-gauge-card
        class="ch_box b2 col-md-2 position-relative"
        type="transformer"
        title="Winding Temperature 1"
        [url]="sensorData + '/oil-level/' + serialNo"
        metric_type=""
        asset_id=""
      >
      </app-gauge-card>
      <app-gauge-card
        class="ch_box b2 col-md-2 position-relative"
        type="transformer"
        title="Winding Temperature 2"
        [url]="sensorData + '/oil-level/' + serialNo"
        metric_type=""
        asset_id=""
      >
      </app-gauge-card>
      <app-gauge-card
        class="ch_box b2 col-md-2 position-relative"
        type="transformer"
        title="Winding Temperature 3"
        [url]="sensorData + '/oil-level/' + serialNo"
        metric_type=""
        asset_id=""
      >
      </app-gauge-card>
      <app-gauge-card
        class="ch_box b2 col-md-2 position-relative"
        type="transformer"
        title="Winding Temperature 4"
        [url]="sensorData + '/oil-level/' + serialNo"
        metric_type=""
        asset_id=""
      >
      </app-gauge-card>
      <!-- <app-gauge-card
        class="ch_box b3 col-md-2 position-relative"
        type="transformer"
        title="Winding Temperature"
        [url]="sensorData + '/winding-temperature/' + serialNo"
        metric_type=""
        asset_id=""
      >
      </app-gauge-card> -->

      <!-- /Oil Temperature -->
      <!-- Oil Level -->
      <!-- <div class="ch_box b2 col-md-2 position-relative">
        <div class="heading">Connector Temperature</div>
        <div class="inner vibrationInner">
          <app-radial-gauge
            matTooltip="Oil Level Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
            [matTooltipClass]="'tooltip'"
            [ngClass]="'custom-css'"
            [inputData]="eTxformerOilLevelData"
          >
          </app-radial-gauge>
        </div>
        <button
          mat-button
          *ngIf="role !== 'OEM'"
          (click)="openExformerGraphSettingsDialog('OilLevel', 1457)"
          class="setting_btn_tf"
        >
          <img src="./assets/settings.png" />
        </button>
      </div> -->
      <!-- /Oil Level -->
      <!-- Wind Temperature -->
      <!-- <div class="ch_box b3 col-md-4 position-relative">
        <div class="heading">Winding Temperature</div>
        <div class="windTemp" style="justify-content: space-around !important">
          <div
            class="inner vibrationInner"
            *ngFor="let windingTemperature of tXformerWendingTemperatureData"
          >
            <ng-container
              *ngIf="windingtemperatureloading; else windingTemperatureid"
            >
              <div class="spinner-container charts-loader">
                <div class="spinner-border text-primary" role="status"></div>
              </div>
            </ng-container>
            <ng-template #windingTemperatureid>
              <app-gauge-chart
                matTooltip=" Winding Temperature Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
                style="color: orange; color: black"
                [canvasWidth]="160"
                [canvasHeight]="140"
                [matTooltipClass]="'tooltip'"
                [ngClass]="'custom-css'"
                [canvasWidth]="canvasWidth"
                [needleValue]="windingTemperature.needleValue"
                [needleColor]="windingTemperature.options.needleColor"
                [centralLabel]="centralLabel"
                [options]="windingTemperature.options"
                [name]="windingTemperature.name"
                [bottomLabel]="windingTemperature.bottomLabel"
              >
              </app-gauge-chart>
            </ng-template>
          </div>
        </div>
        <button
          mat-button
          *ngIf="role !== 'OEM'"
          (click)="openExformerGraphSettingsDialog('WindingTemperature', 1457)"
          class="setting_btn_tf"
        >
          <img src="./assets/settings.png" />
        </button>
      </div> -->
      <!-- /Wind Temperature -->
      <!-- ALERT STATUS -->
      <div class="ch_box b4 col-md-4">
        <div class="heading">24 Hours Alert Summary</div>
      </div>
      <!-- ALERT STATUS -->
    </div>
  </div>

  <!-- Trends -->
  <div class="section d-flex">
    <div class="w-75">
      <div class="sectionHeading">Trends (Actual)</div>
      <div class="summary_boxes_outer w-100">
        <div class="summaryBox w-100" [ngStyle]="{ height: '400px' }"></div>
      </div>
    </div>
    <div class="w-25">
      <div class="sectionHeading">Thermal Snapshot</div>
      <div class="summary_boxes_outer">
        <div class="summaryBox" [ngStyle]="{ height: '400px', width: '100%' }">
          <div class="d-flex justify-content-between align-items-center">
            <select name="" id="" class="form-select" aria-label="Default select example" style="width:40% !important">
              <option value="IRON">IRON</option>
            </select>
            <div class="">
              <button mat-raised-button color="warm">Reset</button>
              <button mat-raised-button color="primary">Apply</button>
            </div>
          </div>
          <div class="d-flex h_70">
            <div class="th-img"></div>
            <div class="th-bar"></div>
          </div>
          <div class=" text-center my-2">15/04/2025 09:29 AM</div>
          <div class="d-flex justify-content-center align-items-center">
            <button mat-raised-button color="primary" class="">
              Take New Snapshot
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Trends -->
</div>
